<script lang="ts" setup>
const props = defineProps({
  clickable: {
    default: false,
    type: Boolean,
  },
  description: {
    default: '',
    type: String,
  },
  hasBorders: {
    default: false,
    type: Boolean,
  },
  legend: {
    default: '',
    type: String,
  },
  power: {
    default: 'welcome',
    type: String as PropType<BasePowerPower | false>,
  },
  powerSize: {
    default: 'sm',
    type: String as PropType<BasePowerSize>,
  },
  size: {
    default: 'sm',
    type: String as PropType<BaseMessageSize>,
  },
  title: {
    default: '',
    type: String,
  },
})

const emit = defineEmits<{
  click: []
}>()

function onClick() {
  if (props.clickable) {
    emit('click')
  }
}
</script>

<template>
  <div
    class="flex flex-col items-center text-center"
    :class="{
      'border-gray-300 dark:border-gray-700': hasBorders,
      'cursor-pointer shadow-inner hover:border-gray-500 hover:bg-gray-200 dark:hover:border-gray-600 dark:hover:bg-gray-800': hasBorders && clickable,
      'rounded-lg border px-4 py-6': hasBorders && size === 'xs',
      'rounded-xl border px-6 py-12': hasBorders && size === 'sm',
      'text-sm': size === 'xs',
      'text-base': size === 'sm',
    }"
    @click="onClick"
  >
    <BasePower
      v-if="power"
      :class="{
        'mb-3': size === 'xs',
        'mb-4': size === 'sm',
      }"
      :power="power"
      :size="powerSize"
    />

    <BaseHeading
      v-if="title"
      class="text-balance"
      :description="description"
      size="2xs"
      :title="title"
    />

    <div
      v-if="$slots.default"
      class="flex flex-col items-center justify-center sm:w-full sm:flex-row"
      :class="{
        'mt-4': size === 'xs',
        'mt-5': size === 'sm',
      }"
    >
      <slot />
    </div>

    <p
      v-if="legend"
      class="mt-6 text-gray-600 dark:text-gray-400"
      :class="{
        'text-xs': size === 'xs',
        'text-sm': size === 'sm',
      }"
      v-html="legend"
    />
  </div>
</template>
